import React, { useState, useEffect } from "react";
import { Select } from "@windmill/react-ui";
import AgentsServices from "services/AgentsServices";

const SelectAgent = ({
  register = () => ({}), // default fallback
  name,
  label,
  value,
  onChange,
  ...props
}) => {
  const [allAgents, setAllAgents] = useState([]);

  useEffect(() => {
    async function fetchAgents() {
      try {
        const response = await AgentsServices.getAgentList();
        setAllAgents(response.data);
      } catch (error) {
        console.error("Error fetching agents:", error);
      }
    }

    fetchAgents();
  }, []);

  return (
    <Select
      name={name}
      value={value}              // controlled
      onChange={onChange}        // controlled
      ref={register(name, {
        required: `${label} is required!`,
      }).ref}
      onBlur={register(name).onBlur}
      className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      {...props}
    >
      <option value="">Select Agent</option>
      {allAgents
        .filter((agent) => agent.status === 1)
        .map((agent) => (
          <option key={agent.id} value={agent.id}>
            {agent.name}
          </option>
        ))}
    </Select>
  );
};

export default SelectAgent;
